import { createScopedDescriptor } from '../../globalState/api';
export const HISTORY_INSTANCE = createScopedDescriptor('historyInstance', 'EXECUTION_CONTEXT');

// TODO: After forking react-router, this state should live in the historyInstance
// and we can remove this state and the context providers
export const HISTORY_BASE_PATH = createScopedDescriptor('historyBasePath', 'EXECUTION_CONTEXT');